/**
 * Snoozebaby Slaapzak Seizoen- & Maatkiezer + TOG Modal
 */
(function () {
  'use strict';

  function mountTogModal(backdrop) {
    if (!backdrop || backdrop.parentNode === document.body) return;
    document.body.appendChild(backdrop);
  }

  function initTogModal() {
    const triggers = document.querySelectorAll('[data-sb-tog-trigger]');
    const backdrop = document.getElementById('sb-tog-modal');
    if (!backdrop) return;

    mountTogModal(backdrop);

    const closers = backdrop.querySelectorAll('[data-sb-tog-close]');

    function openModal() {
      backdrop.removeAttribute('hidden');
      backdrop.style.display = 'flex';
      void backdrop.offsetWidth;
      backdrop.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      backdrop.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (backdrop.getAttribute('data-open') === 'false') {
          backdrop.style.display = 'none';
          backdrop.setAttribute('hidden', '');
        }
      }, 200);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && backdrop.getAttribute('data-open') === 'true') {
        closeModal();
      }
    });

    initTogMobileFilters(backdrop);
  }

  function initTogMobileFilters(backdrop) {
    const mobile = backdrop.querySelector('[data-sb-tog-mobile]');
    if (!mobile) return;

    const bagGroup = mobile.querySelector('[data-sb-tog-bag-filter]');
    const tempGroup = mobile.querySelector('[data-sb-tog-temp-filter]');
    const zones = mobile.querySelectorAll('.sb-tog-zone');
    if (!bagGroup || !tempGroup || !zones.length) return;

    let bag = 'all';
    let temp = 'all';

    function setActive(group, attr, value) {
      group.querySelectorAll('.sb-tog-filter-chip').forEach(function (chip) {
        const on = chip.getAttribute(attr) === value;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function applyFilters() {
      zones.forEach(function (zone) {
        const zoneId = zone.getAttribute('data-zone') || '';
        const opts = zone.querySelectorAll('.sb-tog-opt');
        let visibleOpts = 0;

        opts.forEach(function (opt) {
          const optBag = opt.getAttribute('data-bag') || '';
          const showOpt = bag === 'all' || optBag === bag;
          if (showOpt) {
            opt.removeAttribute('hidden');
            visibleOpts += 1;
          } else {
            opt.setAttribute('hidden', '');
          }
        });

        const showZone = (temp === 'all' || zoneId === temp) && visibleOpts > 0;
        if (showZone) {
          zone.removeAttribute('hidden');
        } else {
          zone.setAttribute('hidden', '');
        }
      });
    }

    bagGroup.addEventListener('click', function (e) {
      const chip = e.target.closest('.sb-tog-filter-chip[data-bag]');
      if (!chip || !bagGroup.contains(chip)) return;
      bag = chip.getAttribute('data-bag') || 'all';
      setActive(bagGroup, 'data-bag', bag);
      applyFilters();
    });

    tempGroup.addEventListener('click', function (e) {
      const chip = e.target.closest('.sb-tog-filter-chip[data-temp]');
      if (!chip || !tempGroup.contains(chip)) return;
      temp = chip.getAttribute('data-temp') || 'all';
      setActive(tempGroup, 'data-temp', temp);
      applyFilters();
    });
  }

  const SUBLINE_SELECTOR = '.sb-slaapzak-subline__text';
  const SUBLINE_MIN_SCALE = 0.7;
  const SUBLINE_STEP_PX = 0.25;
  const SUBLINE_MAX_STEPS = 40;
  let sublineResizeTimer;
  let suppressSublineRo = false;
  /** Gedeelde font-size per grid-index, zodat AJAX-swap niet eerst groot flitst. */
  var sublineSizeCache = [];

  function sublineOverflows(el) {
    return el.scrollWidth > el.clientWidth + 0.5;
  }

  function applySizeToTexts(texts, px) {
    texts.forEach(function (el) {
      el.style.fontSize = px;
    });
  }

  function readCssBaseFontSize(el) {
    var prev = el.style.fontSize;
    el.style.fontSize = '';
    var base = parseFloat(getComputedStyle(el).fontSize);
    el.style.fontSize = prev;
    return base;
  }

  function fitSublineGroup(texts, cacheIndex) {
    if (!texts || !texts.length) return;

    var base = readCssBaseFontSize(texts[0]);
    if (!base || Number.isNaN(base)) return;

    var floor = base * SUBLINE_MIN_SCALE;
    var size = base;
    var steps = 0;
    var cached = cacheIndex != null ? sublineSizeCache[cacheIndex] : null;

    // Start met cache of basis, nooit zichtbaar "leeg" (CSS groot) laten staan
    if (cached) {
      var cachedNum = parseFloat(cached);
      if (!Number.isNaN(cachedNum) && cachedNum > 0) {
        size = Math.min(base, cachedNum);
      }
    }

    function anyOverflows() {
      for (var i = 0; i < texts.length; i += 1) {
        if (sublineOverflows(texts[i])) return true;
      }
      return false;
    }

    applySizeToTexts(texts, size + 'px');

    while (anyOverflows() && size > floor && steps < SUBLINE_MAX_STEPS) {
      size -= SUBLINE_STEP_PX;
      applySizeToTexts(texts, size + 'px');
      steps += 1;
    }

    // Als cache te klein was: probeer groter tot het net past
    if (cached && size + SUBLINE_STEP_PX <= base && !anyOverflows()) {
      while (size + SUBLINE_STEP_PX <= base && steps < SUBLINE_MAX_STEPS) {
        var next = size + SUBLINE_STEP_PX;
        applySizeToTexts(texts, next + 'px');
        if (anyOverflows()) {
          applySizeToTexts(texts, size + 'px');
          break;
        }
        size = next;
        steps += 1;
      }
    }

    if (cacheIndex != null) {
      sublineSizeCache[cacheIndex] = size + 'px';
    }
  }

  function fitAllSublines(root) {
    suppressSublineRo = true;
    try {
      var scope = root && root.querySelectorAll ? root : document;
      var grids = scope.querySelectorAll('[data-sb-slaapzak-picker] .sb-slaapzak-grid');

      if (grids.length) {
        grids.forEach(function (grid, index) {
          fitSublineGroup(grid.querySelectorAll(SUBLINE_SELECTOR), index);
        });
      } else {
        fitSublineGroup(scope.querySelectorAll(SUBLINE_SELECTOR), 0);
      }
    } finally {
      requestAnimationFrame(function () {
        suppressSublineRo = false;
      });
    }
  }

  /** Zet gecachte maten op nieuwe HTML vóór first paint (geen groote-flits). */
  function applyCachedSublineSizes(node) {
    if (!node || !node.querySelectorAll) return;
    var grids = node.querySelectorAll('[data-sb-slaapzak-picker] .sb-slaapzak-grid');
    grids.forEach(function (grid, index) {
      var cached = sublineSizeCache[index];
      if (!cached) return;
      applySizeToTexts(grid.querySelectorAll(SUBLINE_SELECTOR), cached);
    });
  }

  function scheduleFitSublines(root) {
    if (suppressSublineRo) return;
    clearTimeout(sublineResizeTimer);
    sublineResizeTimer = window.setTimeout(function () {
      if (suppressSublineRo) return;
      fitAllSublines(root);
    }, 120);
  }

  function observeSublineFit(root) {
    if (typeof ResizeObserver === 'undefined') return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sb-slaapzak-picker]').forEach(function (picker) {
      if (picker.dataset.sbSublineFitObserved === 'true') return;
      picker.dataset.sbSublineFitObserved = 'true';
      var ro = new ResizeObserver(function () {
        if (suppressSublineRo) return;
        scheduleFitSublines(picker);
      });
      ro.observe(picker);
    });
  }

  function initSublineFit(root) {
    fitAllSublines(root);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitAllSublines(root);
      }).catch(function () {
        fitAllSublines(root);
      });
    }
    observeSublineFit(root);
  }

  window.SnoozebabySlaapzakSublineFit = { fitAll: fitAllSublines };

  var ajaxBound = false;
  var switchAbort = null;
  var switchGeneration = 0;
  var prefetchCache = Object.create(null);

  function pickerLinkFromEvent(e) {
    var el = e.target;
    if (!el || !el.closest) return null;
    return el.closest(
      '[data-sb-slaapzak-picker] a.sb-slaapzak-card, [data-sb-slaapzak-picker] a.sb-slaapzak-swatch'
    );
  }

  function samePageUrl(a, b) {
    try {
      var ua = new URL(a, window.location.origin);
      var ub = new URL(b, window.location.origin);
      return ua.pathname === ub.pathname && ua.search === ub.search;
    } catch (err) {
      return a === b;
    }
  }

  function sectionFetchUrl(productUrl, sectionId) {
    var url = new URL(productUrl, window.location.origin);
    if (sectionId) {
      url.searchParams.set('section_id', sectionId);
    }
    return url.toString();
  }

  function cleanupBodyTogModals() {
    document.querySelectorAll('body > #sb-tog-modal').forEach(function (el) {
      el.remove();
    });
  }

  /** Live product-info; skip leftover hidden nodes from prior viewTransition swaps. */
  function liveProductInfo() {
    var nodes = document.querySelectorAll('product-info[id^="MainProduct"]');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].style.display === 'none') continue;
      return nodes[i];
    }
    return nodes[0] || null;
  }

  /** Remove hidden double-buffer nodes from HTMLUpdateUtility.viewTransition. */
  function cleanupStaleProductInfos(keep) {
    document.querySelectorAll('product-info[id^="MainProduct"]').forEach(function (el) {
      if (el === keep) return;
      if (el.style.display === 'none') el.remove();
    });
  }

  function fetchSectionHtml(fetchUrl, signal) {
    return fetch(fetchUrl, {
      credentials: 'same-origin',
      signal: signal,
    }).then(function (res) {
      if (!res.ok) throw new Error('Network error');
      return res.text();
    });
  }

  function afterProductSwap(root, targetUrl, scrollY, lockedHeight, generation) {
    if (generation !== switchGeneration) return;

    suppressSublineRo = true;
    window.history.pushState({ sbSlaapzakAjax: true }, '', targetUrl);
    window.scrollTo(0, scrollY);

    if (root && lockedHeight) {
      root.style.minHeight = lockedHeight + 'px';
    }

    cleanupBodyTogModals();
    cleanupStaleProductInfos(root);
    initTogModal();
    document.dispatchEvent(new CustomEvent('sb-pdp-swapped'));

    // Sync fit nu (cache al toegepast vóór insert); geen delayed reset naar grote tekst
    fitAllSublines(root || document);
    observeSublineFit(root || document);

    if (window.SnoozebabyProductReadmore && window.SnoozebabyProductReadmore.reinitIn && root) {
      window.SnoozebabyProductReadmore.reinitIn(root);
    }
    if (window.SnoozebabyPdpTitleFit && window.SnoozebabyPdpTitleFit.fitAll) {
      window.SnoozebabyPdpTitleFit.fitAll(root || document);
    }
    if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
      window.Shopify.PaymentButton.init();
    }

    requestAnimationFrame(function () {
      if (generation !== switchGeneration) return;
      window.scrollTo(0, scrollY);
      window.setTimeout(function () {
        if (generation !== switchGeneration) return;
        window.scrollTo(0, scrollY);
        if (root) root.style.minHeight = '';
        // Pas ná layout-stabilisatie RO weer toe, zonder meteen te herfitten
        window.setTimeout(function () {
          if (generation !== switchGeneration) return;
          suppressSublineRo = false;
        }, 200);
      }, 120);
    });
  }

  function markOptimisticActive(link) {
    var picker = link.closest('[data-sb-slaapzak-picker]');
    if (!picker) return;

    var group = link.closest('.sb-slaapzak-grid, .sb-slaapzak-swatches, .sb-slaapzak-group');
    if (!group) group = picker;

    group.querySelectorAll('a.sb-slaapzak-card, a.sb-slaapzak-swatch').forEach(function (el) {
      el.classList.remove('sb-slaapzak-card--active', 'sb-slaapzak-swatch--active');
      el.removeAttribute('aria-current');
    });

    link.classList.add(
      link.classList.contains('sb-slaapzak-swatch') ? 'sb-slaapzak-swatch--active' : 'sb-slaapzak-card--active'
    );
    link.setAttribute('aria-current', 'page');
  }

  function prefetchPickerUrl(href) {
    if (!href || href.indexOf('#') !== -1 || prefetchCache[href]) return;
    var productInfo = liveProductInfo();
    var sectionId = productInfo && productInfo.dataset.section;
    prefetchCache[href] = fetch(sectionFetchUrl(href, sectionId), {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('prefetch failed');
        return res.text();
      })
      .catch(function () {
        delete prefetchCache[href];
        return null;
      });
  }

  function swapProductSection(targetUrl) {
    var productInfo = liveProductInfo();
    if (!productInfo) {
      window.location.href = targetUrl;
      return;
    }

    var sectionId = productInfo.dataset.section;
    var scrollY = window.scrollY;
    var lockedHeight = productInfo.offsetHeight;
    var fetchUrl = sectionFetchUrl(targetUrl, sectionId);

    if (switchAbort) switchAbort.abort();
    switchAbort = new AbortController();
    var signal = switchAbort.signal;
    var generation = ++switchGeneration;

    var cached = prefetchCache[targetUrl];
    delete prefetchCache[targetUrl];

    // Prefetch is niet abortbaar; bij fail/null opnieuw fetchen i.p.v. full-page navigatie
    var pending = cached
      ? cached.then(function (html) {
          if (html) return html;
          return fetchSectionHtml(fetchUrl, signal);
        })
      : fetchSectionHtml(fetchUrl, signal);

    pending
      .then(function (html) {
        if (generation !== switchGeneration || signal.aborted) return;
        if (!html) throw new Error('Empty response');

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInfo =
          doc.querySelector('product-info[id^="MainProduct"]') || doc.querySelector('product-info');

        if (!newInfo) {
          throw new Error('Missing product-info');
        }

        // Altijd de live node pakken: bij snelle klikken is de start-referentie al vervangen
        var currentInfo = liveProductInfo();
        if (!currentInfo) {
          throw new Error('Missing live product-info');
        }

        cleanupBodyTogModals();
        applyCachedSublineSizes(newInfo);

        var pre = [
          function (node) {
            node.querySelectorAll('.scroll-trigger').forEach(function (el) {
              el.classList.add('scroll-trigger--cancel');
            });
            applyCachedSublineSizes(node);
          },
        ];

        var post = [
          function (newNode) {
            afterProductSwap(newNode, targetUrl, scrollY, lockedHeight, generation);
          },
        ];

        if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.viewTransition) {
          HTMLUpdateUtility.viewTransition(currentInfo, newInfo, pre, post);
        } else {
          currentInfo.style.minHeight = lockedHeight + 'px';
          currentInfo.replaceWith(newInfo);
          afterProductSwap(newInfo, targetUrl, scrollY, lockedHeight, generation);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Verouderde request of nieuwere klik: geen hard reload (dat springt naar boven)
        if (generation !== switchGeneration || signal.aborted) return;
        window.location.href = targetUrl;
      });
  }

  function initAjaxSwitching() {
    if (ajaxBound) return;
    ajaxBound = true;

    document.addEventListener(
      'click',
      function (e) {
        var link = pickerLinkFromEvent(e);
        if (!link || !link.href || link.getAttribute('href') === '#') return;
        if (link.origin && link.origin !== window.location.origin) return;
        if (samePageUrl(link.href, window.location.href)) {
          e.preventDefault();
          return;
        }

        e.preventDefault();
        markOptimisticActive(link);
        swapProductSection(link.href);
      },
      false
    );

    document.addEventListener(
      'pointerenter',
      function (e) {
        var link = pickerLinkFromEvent(e);
        if (!link || !link.href || link.getAttribute('href') === '#') return;
        if (link.origin && link.origin !== window.location.origin) return;
        if (samePageUrl(link.href, window.location.href)) return;
        prefetchPickerUrl(link.href);
      },
      true
    );

    window.addEventListener('popstate', function () {
      if (!document.querySelector('[data-sb-slaapzak-picker]')) return;
      swapProductSection(window.location.href);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTogModal();
      initAjaxSwitching();
      initSublineFit();
    });
  } else {
    initTogModal();
    initAjaxSwitching();
    initSublineFit();
  }
})();
